// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ImportAccountUserDto extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String */
  apiLink?: string;
  /** String */
  email!: string;
  /** String */
  error!: string;
  /** String */
  firstName!: string;
  /** String */
  gender!: string;
  /** Int32 */
  hireDate?: number;
  /** String */
  lastName!: string;
  /** String */
  middleName!: string;
  /** String */
  programUserGroupCode?: string;
  /** String */
  programUserGroupId?: string;
  /** String */
  result!: string;
  /** String */
  salutation!: string;
  /** String */
  shippingUserGroupCode?: string;
  /** String */
  shippingUserGroupId?: string;
  /** String */
  status!: string;
  /** String */
  userName!: string;
}

